export const FirearmCaliberConstants = {
    NOT_ON_LIST: '71b5f274-1f05-4e4c-a386-5f049194a2c5',
};